/** Libraries * */
import noop from "lodash/noop";
import React from "react";
import {string} from "yup";
import {useTranslation} from "@unibuddy/intl";
import {Button, DateInput, FormGroup, Select, Stack, TextInput} from "@unibuddy/patron";

import {IntlNamespaces} from "../../../../translations/types";
import {INTL_SELECT, INTL_SELECT_DATE, INTL_TODAY} from "../../../../translations/settings";
import {INTL_REQUIRED_FIELD} from "../../../../translations/validations";

/**
 * Component to render the custom attributes section of the signup form.
 * This is conditionally rendered based on output of the hasFeature query.
 * Form groups handle the values internally and are available to the submit method
 * along with the rest of the values.
 * @returns {*}
 */

// TODO: Make TS and named export
const CustomAttributesSection = ({attributes, initialValues = {}, handleFormChange = noop}) => {
    const {t} = useTranslation([IntlNamespaces.SETTINGS, IntlNamespaces.VALIDATIONS]);

    return (
        <Stack space={"small"}>
            {attributes
                .filter((attribute) => !attribute.type.includes("static"))
                .map((attribute) => {
                    const {id, type, name, options, required} = attribute;
                    let validation = string().nullable();
                    validation = required
                        ? validation.required(
                              `${name}${t(
                                  `${IntlNamespaces.VALIDATIONS}:${INTL_REQUIRED_FIELD.key}`,
                                  INTL_REQUIRED_FIELD.defaultValue,
                              )}`,
                          )
                        : validation;
                    return (
                        <FormGroup
                            label={name}
                            key={id}
                            id={id}
                            initialValue={initialValues[id] || null}
                            validation={validation}
                            onChange={async (e) => {
                                await handleFormChange(e);
                            }}
                        >
                            {(() => {
                                switch (type) {
                                    case "single_choice":
                                        return (
                                            <Select
                                                id={id}
                                                name={id}
                                                required={required}
                                                placeholder={t(
                                                    INTL_SELECT.key,
                                                    INTL_SELECT.defaultValue,
                                                )}
                                                formatValue={(e) => e}
                                            >
                                                {options && options.length
                                                    ? options.map((o) => (
                                                          <option key={o.id} value={o.id}>
                                                              {o.value}
                                                          </option>
                                                      ))
                                                    : null}
                                            </Select>
                                        );
                                    case "date":
                                        return (
                                            <DateInput
                                                id={id}
                                                name={id}
                                                showMonthDropdown
                                                showYearDropdown
                                                required={required}
                                                placeholder={t(
                                                    `${IntlNamespaces.SETTINGS}:${INTL_SELECT_DATE.key}`,
                                                    INTL_SELECT_DATE.defaultValue,
                                                )}
                                                todayButton={
                                                    <Button size="small" clear>
                                                        {t(
                                                            `${IntlNamespaces.SETTINGS}:${INTL_TODAY.key}`,
                                                            INTL_TODAY.defaultValue,
                                                        )}
                                                    </Button>
                                                }
                                            />
                                        );
                                    case "open_text_field":
                                        return <TextInput id={id} name={id} required={required} />;
                                    default:
                                        return null;
                                }
                            })()}
                        </FormGroup>
                    );
                })}
        </Stack>
    );
};

export default CustomAttributesSection;
